import { render, staticRenderFns } from "./AuthMethodExternal.vue?vue&type=template&id=4ef31337&"
import script from "./AuthMethodExternal.vue?vue&type=script&lang=ts&"
export * from "./AuthMethodExternal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports